<template>
	<v-dialog v-model="isDialogOpen" :scrim="false" width="40%">
		<v-card>
			<v-card-title class="d-flex align-center justify-space-between">
				{{ $t("SELECT_STRUCTURE_TYPE") }}
				<v-btn icon variant="flat" @click="closeDialog">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-container v-for="type in SIMPLE_STRUCTURE_TYPES" :key="type.id" class="type-select-btn ma-4">
					<v-row>
						<v-col>
							<v-card class="card-btn" @click="selectTypeAndConfirm(type.id)">
								<v-row class="ma-0">
									<v-col cols="2" class="icon">
										<v-icon size="34" color="white">
											{{ type.icon || "mdi-cube" }}
										</v-icon>
									</v-col>
									<v-col cols="10">
										<v-card-title class="card-btn-title">{{ $t(type.labelKey) }}</v-card-title>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import {
	SIMPLE_STRUCTURE_TYPE,
	type TSimpleStructureType,
} from "@/models/objects/solidMesh/types";
import { computed } from "vue";
import { SIMPLE_STRUCTURE_TYPES } from "./SimpleStructureTypeConfig";

const props = defineProps<{
	modelValue: boolean;
}>();

const emit = defineEmits<{
	(e: "update:modelValue", value: boolean): void;
	(e: "select", typeId: TSimpleStructureType): void;
	(e: "select-manual"): void;
}>();

const isDialogOpen = computed({
	get: () => props.modelValue,
	set: (value: boolean) => emit("update:modelValue", value),
});

function selectTypeAndConfirm(typeId: TSimpleStructureType) {
	if (typeId === SIMPLE_STRUCTURE_TYPE.MANUAL) {
		// SolidMesh workflow for custom
		emit("select-manual");
	} else {
		// SimpleStracture workflow for Box-culvert, Manhole, Pipe, Retaining-wall
		emit("select", typeId);
	}
	isDialogOpen.value = false;
}

function closeDialog() {
	isDialogOpen.value = false;
}
</script>

<style scoped>
.card-btn {
	display: flex;
	align-items: center;
	height: 110px;
}

.card-btn:hover {
	background-color: #2e2e2e;
}

.card-btn-title {
	white-space: normal
}

.icon {
	display: flex;
	justify-content: center;
	align-items: center;
}

.type-select-btn {
	width: 90%;
}
</style>
